import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f270f02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-0 w-full p-2 text-left text-white z-30"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.snackbar.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["w-full sm:max-w-lg p-4 mx-auto rounded-md shadow-md", {
          success: _ctx.snackbar.severity === 'success',
          error: _ctx.snackbar.severity === 'error',
        }])
            }, _toDisplayString(_ctx.snackbar.message), 3)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}